import Enum from "../../../../../../enums/Enum";

const TimelinePeriodEnum = new Enum({
    DAY: {name: "Day"},
    WEEK: {name: "Week"},
    MONTH: {name: "Month"}
});

export default TimelinePeriodEnum;
